// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2DbEK","bigColWidth":"Table_bigColWidth__3WeGO","biggerColWidth":"Table_biggerColWidth__2qTjM","row":"Table_row__2Sayd","col":"Table_col__2VvO1"};